import React, { Component } from 'react'
import { Select } from 'antd'
import _ from 'lodash'

import './DocumentContentForm.scss'
import DocumentContentTable from '../DocumentContentTable/DocumentContentTable'

const { Option } = Select

export default class DocumentContentForm extends Component {
    render() {
        const { status, type: docType, smartSaerchFilter, onSmartSearchFilterChange, isDocumentSent, locationList, estateList } = this.props
        const { category, type, size, siteLocation, estateName } = smartSaerchFilter
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent || docType === 'variation-order' || docType === 'working-progress' || docType === 'work-progress-report'

        return (
            <div className="DocumentContentForm">
                { !isLocked && <h3>Please select filter to limit the smart suggestion result.</h3> }
                { !isLocked &&
                    <div className="filter">
                        <Select 
                            placeholder="Category" 
                            dropdownMatchSelectWidth={false} 
                            value={category}
                            onChange={onSmartSearchFilterChange.bind(this, 'category')}
                            allowClear
                        >
                            <Option value="RE">RE</Option>
                            <Option value="OF">OF</Option>
                            <Option value="MI">MI</Option>
                        </Select>
                        <Select 
                            placeholder="Type" 
                            dropdownMatchSelectWidth={false} 
                            value={type}
                            onChange={onSmartSearchFilterChange.bind(this, 'type')}
                            allowClear
                        >
                            <Option value="Apartment">Apartment</Option>
                            <Option value="House">House</Option>
                            <Option value="Subdivided Flat">Subdivided Flat</Option>
                            <Option value="Shop">Shop</Option>
                            <Option value="NGO">NGO</Option>
                            <Option value="Restaurant">Restaurant</Option>
                            <Option value="Elderly House">Elderly House</Option>
                            <Option value="School">School</Option>
                            <Option value="Office">Office</Option>
                        </Select>
                        <Select 
                            placeholder="Size" 
                            dropdownMatchSelectWidth={false} 
                            value={size}
                            onChange={onSmartSearchFilterChange.bind(this, 'size')}
                            allowClear
                        >
                            <Option value="<= 300">&lt;= 300</Option>
                            <Option value="301 - 500">301 - 500</Option>
                            <Option value="501 - 800">501 - 800</Option>
                            <Option value="> 800">&gt; 800</Option>
                        </Select>
                        <Select 
                            placeholder="Location" 
                            dropdownMatchSelectWidth={false} 
                            value={siteLocation}
                            onChange={onSmartSearchFilterChange.bind(this, 'siteLocation')}
                            allowClear
                        >
                            {
                                _.map(locationList, (location, i) => (
                                    <Option key={location} value={location}>{location}</Option>
                                ))
                            }
                        </Select>
                        <Select 
                            placeholder="Estate" 
                            dropdownMatchSelectWidth={false} 
                            value={estateName}
                            onChange={onSmartSearchFilterChange.bind(this, 'estateName')}
                            allowClear
                        >
                            {
                                _.map(estateList, (estate, i) => (
                                    <Option key={estate} value={estate}>{estate}</Option>
                                ))
                            }
                        </Select>
                    </div>
                }
                <DocumentContentTable
                    {...this.props}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/DocumentContentForm/DocumentContentForm.js